<template>
  <div
    @click.stop="handleClick()"
    class="booking"
    :style="getStyle(data)"
    >
      <h5 :class="{ 'small-text': small }">{{ timeString(data) }}</h5>
      <h5 :class="{ 'small-text': small }" v-if="!medium">{{ data.title }}</h5>
      <h5 v-if="!(small || medium)" >{{ data.who }}</h5>
  </div>
</template>

<script>
export default {
  name: 'Booking',
  props: ['data'],
  data () {
    return {
      small: false,
      medium: false,
    }
  },
  methods: {
    handleClick () {
      this.$router.push({ name: 'BookingEditView', params: { date: this.data.date, id: this.data.id, edit: true }});
    },
    timeString (booking) {
      return `${booking.start} - ${booking.end}`
    },
    getStyle (booking) {
      const firstHour = 8;
      const hourHeight = 3;
      let start = booking.start.split(':')
      let end = booking.end.split(':')
      let duration = [ end[0] - start[0], end[1] - start[1] ]
      let top = start[0] * hourHeight - firstHour * hourHeight + start[1] / 60 * hourHeight
      let height = duration[0] * hourHeight + duration[1] / 60 * hourHeight
      return {top: top + 'em', height: height + 'em'}
    }
  },
  mounted () {
    const h = this.$el.offsetHeight;
    this.small = h < 32;
    this.medium = h < 48;
  }
}
</script>

<style lang="sass" scoped>

@import 'src/color.scss'
@import 'src/values.scss'

.booking
  //border: 1px solid $secondary-dark
  //border-radius: 1em
  color: $secondary-text
  position: absolute
  width: 100%
  //background: -webkit-linear-gradient($secondary-light, $secondary 120%)
  background-color: $secondary-light
  box-sizing: border-box
  overflow: hidden
  cursor: pointer
  padding: 1px

  transition: $transition-time all

.booking:hover
  background-color: $secondary

.booking h5
  margin: 0
  // height: 33.3%
  padding: 0

.booking span
  width: 100%
  // height: 33.3%
  position: absolute
  // bottom: 0
  left: 0
  padding: 0

.small-text
  font-size: 80%

</style>



// WEBPACK FOOTER //
// src/components/Booking.vue